import { Injectable } from '@angular/core';
import { createAction, props, Store } from '@ngrx/store';
import { Observable, timer } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { ComponentModel, OTPServiceModel, PathValueModel } from '../../form-json.types';
import { ApiService, OTPSMSRes } from '../api/api.service';
import { DataService } from '../data/data.service';
import { FormCoreModule } from '../form-core.module';
import { updateView } from '../parser/parser.service';
import { ValueService } from '../value/value.service';

@Injectable({
  providedIn: FormCoreModule
})
export class OtpService {

  constructor(private api: ApiService, private data: DataService, private value: ValueService, private store: Store) { }

  initiate(otpService: OTPServiceModel): Observable<OTPSMSRes> {
    const mobileNo = otpService.relationships['mobile-no-field']?.data && `${otpService.attributes.prefix}${this.data.getControl(this.data.getModel<ComponentModel>(otpService.relationships['mobile-no-field'].data).attributes.path).value}`
    const otp = otpService.relationships['otp-field']?.data && this.data.getControl(this.data.getModel<ComponentModel>(otpService.relationships['otp-field'].data).attributes.path).value
    const formId = this.data.attributes['form-id']
    const countryCode = otpService.attributes['country-code']
    const serviceId = otpService.relationships['service-id-field']?.data && this.value.assign(otpService.relationships['service-id-field'].data)
    const prdName = otpService.attributes['prd-name']
    const lastSentMobileNoFieldPath = otpService.relationships['last-sent-mobile-no-field']?.data && this.data.getModel<PathValueModel>(otpService.relationships['last-sent-mobile-no-field'].data).attributes.path
    const serviceIdPath = this.data.getModel<PathValueModel>(otpService.relationships['service-id-field'].data).attributes.path
    const resendStatusPath = otpService.relationships['resend-status-field']?.data && this.data.getModel<PathValueModel>(otpService.relationships['resend-status-field'].data).attributes.path
    switch (otpService.attributes.action) {
      case 'otpSMSGen':
        return this.api.otpSMSGen(`${otpService.attributes['relative-post-url']}otpSMSGen`, { action: '1', countryCode, prdName, mobileNo, formId }).pipe(
          tap(({ status, serviceId, errorCode, errorMessage }) => {
            this.data.pathValue[serviceIdPath] = serviceId
            this.store.dispatch(otpResAction({id: otpService.id, res: {status, serviceId, errorMessage, errorCode}}))
            if (status === '1') {
              this.data.pathValue[lastSentMobileNoFieldPath] = mobileNo
              this.data.pathValue[resendStatusPath] = '0'
              timer(parseInt(otpService.attributes['show-resend-timer'])).pipe(first()).subscribe(() => {
                this.data.pathValue[resendStatusPath] = '1'
                this.store.dispatch(updateView())
              })
            }
          },(e) => this.store.dispatch(otpResAction({id: otpService.id, res: e}))
          )
        )
      case 'otpSMSGen-resendOTPSMS':
        this.data.pathValue[resendStatusPath] = '0'
        this.store.dispatch(updateView())
        timer(parseInt(otpService.attributes['show-resend-timer'])).pipe(first()).subscribe(() => {
          this.data.pathValue[resendStatusPath] = '1'
          this.store.dispatch(updateView())
        })
        return this.api.resendOTPSMS(`${otpService.attributes['relative-post-url']}resendOTPSMS`, { action: '3', serviceId, countryCode }).pipe(
          tap(({errorMessage, status}) => 
            this.data.pathValue[this.data.getModel<PathValueModel>(otpService.relationships['validate-status-field'].data).attributes.path] = errorMessage)
        )
      case 'otpSMSValidate':
        return this.api.otpSMSValidate(`${otpService.attributes['relative-post-url']}otpSMSValidate`, { action: '2', countryCode, serviceId, otp }).pipe(
          tap(({ errorMessage }) => {
            this.data.pathValue[this.data.getModel<PathValueModel>(otpService.relationships['validate-status-field'].data).attributes.path] = errorMessage
          })
        )
    }
  }
}

export const otpResAction = createAction(
  'otp-service',
  props<{id: string, res: OTPSMSRes}>()
)